import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import useSmartBack from "../../hooks/useSmartBack";

function RoleAtRisk() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();
  const handleBack = useSmartBack("/role/list");
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);


  const clampPercent = (value) => {
  const v = parseFloat(value);
  if (isNaN(v)) return 0;
  return Math.max(0, Math.min(v, 100));
};

  const columns = [
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 300,
      enableColumnResizing: true,
      Cell: ({ row }) => (
        <Link to={`/role/view/${row.original.role_id}`}>
          {row.original.role_name}
        </Link>
      ),
    },
    {
      accessorKey: "company_name",
      header: "Clients",
      size: 250,
      enableResizing: false,
    },
    {
      accessorKey: "role_manager",
      header: "Role Manager",
      size: 200,
    },
    {
      accessorKey: "weighted_points",
      enableSorting: true, // ✅ allows sorting
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ fontSize: "14px" }}>Role Risk%</span>
        </div>
      ),
      size: 170,
      Cell: ({ cell }) => {
        const value = parseFloat(cell.getValue() || 0);
        return (
          <span
            style={{
              color: value >= 50 ? "red" : "black",
              fontWeight: "bold",
            }}
          >
            {value.toFixed(1)}
          </span>
        );
      },
    },

    {
      accessorKey: "briefed_dropped_vs_profiles_added_pct",
      header: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap", // ✅ keep in one line
          }}
        >
          <span style={{ fontSize: "14px", color: "black" }}>
            Longlist to briefed below 30%
          </span>
        </div>
      ),
      size: 340, // ✅ Adjusted width for full visibility
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value < 30 ? "red" : "black" }}>{clampPercent(value)}</span>
        );
      },
    },
    {
      accessorKey: "brief_to_eval_conversion_pct",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Drop-offs %</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Brief to evaluate less than 30%
          </span>
        </div>
      ),
      size: 340,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value < 30 ? "red" : "black" }}> {value}</span>
        );
      },
    },
    {
      accessorKey: "recommend_to_shortlist_pct",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Drop-offs %</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Recommend to shortlist less than 60%
          </span>
        </div>
      ),
      size: 340,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value < 60 ? "red" : "black" }}>{value}</span>
        );
      },
    },
    {
      accessorKey: "drop_percentage_of_profiles_added",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Drop-offs %</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Profiles dropped more than 60%
          </span>
        </div>
      ),
      size: 340,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value > 60 ? "red" : "black" }}>{value}</span>
        );
      },
    },
    {
      accessorKey: "interview_setup_to_complete_pct",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Client Engagement %</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            30%+ shortlisted profiles pending interviews
          </span>
        </div>
      ),
      size: 400,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value < 70 ? "red" : "black" }}>{value}</span>
        );
      },
    },
    {
      accessorKey: "last_brief_within_1_weeks",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Time & SLA</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Briefing stuck 1 weeks
          </span>
        </div>
      ),
      size: 240,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value == "Yes" ? "red" : "black" }}>
            {value}
          </span>
        );
      },
    },
    {
      accessorKey: "evaluated_no_recent_recommendation",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Time & SLA</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Recommendation since 10 days
          </span>
        </div>
      ),
      size: 295,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value === "Yes" ? "red" : "black" }}>
            {value}
          </span>
        );
      },
    },
    {
      accessorKey: "interview_done_no_offer_closed_10_days",
      header: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>Time & SLA</span> */}
          <span style={{ fontSize: "14px", color: "black" }}>
            Offer acceptance delay more than 10 days
          </span>
        </div>
      ),
      size: 370,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <span style={{ color: value == "Yes" ? "red" : "black" }}>
            {value}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/roles/get_risk_roles/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.backup_items_list);
        setoptions(response.data.backup_items_list || []);
        setOptionsLoaded(true);
      } catch (error) {
        console.error("API Error:", error);
        setoptions([]); // Prevent errors from breaking UI
        setOptionsLoaded(true);
      } finally {
        setOptionsLoaded(true);
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
      console.log(options);
    }
  }, [options]);

  useEffect(() => {
    $('[name="role_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/roles/roleLoad/`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term })
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Roles",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No Role found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='role_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/role/view/${selectedValues}`);
    });

    return () => {
      $("[name='role_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Roles At Risk</h2>
          </div>
            <div className="my-auto">
              <button
                 className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"

                onClick={handleBack}
              >
                <i className="ti ti-arrow-left me-1"></i>  Back

              </button>
            </div>
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center row-gap-3">
            <h5>Quick Search:</h5>
            <div className="col-md-10 mx-sm-2">
              <div className="input-icon-end position-relative remove-icon">
                <select
                  style={{ width: "100%" }}
                  {...register("role_search", {
                    required: false,
                  })}
                  id="select-client"
                ></select>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <div className="row p-4 mt-3">
                {options.length > 0 && (
                  <MaterialReactTable
                    columns={columns}
                    data={options.map((data) => {
                      console.log(data);
                      // same formula as in your column
                      const metrics = [
                        {
                          value: clampPercent(data.briefed_dropped_vs_profiles_added_pct),
                          threshold: 30,
                          weight: 0.1,
                          below: true,
                        },
                        {
                          value: data.brief_to_eval_conversion_pct,
                          threshold: 30,
                          weight: 0.1,
                          below: true,
                        },
                        {
                          value: data.recommend_to_shortlist_pct,
                          threshold: 60,
                          weight: 0.1,
                          below: true,
                        },
                        {
                          value: data.drop_percentage_of_profiles_added,
                          threshold: 60,
                          weight: 0.1,
                          below: false,
                        },
                        {
                          value: data.interview_setup_to_complete_pct,
                          threshold: 70,
                          weight: 0.1,
                          below: true,
                        },
                        {
                          value: data.last_brief_within_1_weeks,
                          weight: 0.15,
                          type: "yesRisk",
                        },
                        {
                          value: data.evaluated_no_recent_recommendation,
                          weight: 0.2,
                          type: "noRisk",
                        },
                        {
                          value: data.interview_done_no_offer_closed_10_days,
                          weight: 0.15,
                          type: "yesRisk",
                        },
                      ];

                      const computeSubScore = (item) => {
                        if (item.type === "yesRisk")
                          return (item.value || "").toUpperCase() === "YES"
                            ? 100
                            : 0;
                        if (item.type === "noRisk")
                          return (item.value || "").toUpperCase() === "NO"
                            ? 100
                            : 0;

                        const input = parseFloat(item.value) || 0;
                        if (item.below)
                          return (
                            Math.max(
                              0,
                              (item.threshold - input) / item.threshold
                            ) * 100
                          );
                        else
                          return (
                            Math.max(
                              0,
                              (input - item.threshold) / item.threshold
                            ) * 100
                          );
                      };

                      const totalWeighted = metrics.reduce((sum, item) => {
                        const sub = computeSubScore(item);
                        return sum + sub * item.weight;
                      }, 0);

                      // ✅ Attach computed value for sorting
                      return { ...data, weighted_points: totalWeighted };
                    })}
                    enableSorting
                    enableGrouping
                    enableColumnResizing
                    initialState={{
                      density: "compact",
                      expanded: {}, // expand groups by default
                      pagination: { pageSize: 100 },
                      columnOrder: [
                        "role_name",
                        "company_name",
                        "role_manager",
                        "weighted_points",
                        "briefed_dropped_vs_profiles_added_pct",
                        "brief_to_eval_conversion_pct",
                        "recommend_to_shortlist_pct",
                        "drop_percentage_of_profiles_added",
                        "interview_setup_to_complete_pct",
                        "last_brief_within_1_weeks",
                        "evaluated_no_recent_recommendation",
                        "interview_done_no_offer_closed_10_days",
                      ],
                      sorting: [
                        {
                          id: "weighted_points", // the accessorKey of the column to sort by
                          desc: true, // descending order
                        },
                      ],
                      columnPinning: {
                        left: [], // 👈 no pinned columns
                        right: [],
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RoleAtRisk;
